import {
  ActionIcon,
  ActionIconProps,
  useComputedColorScheme,
  useMantineColorScheme,
} from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';

export type ThemeToggleProps = ActionIconProps;

export const ThemeToggle = ({ ...props }: ThemeToggleProps) => {
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('light');
  const isDark = computedColorScheme === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <ActionIcon
      variant='outline'
      color={isDark ? 'yellow' : 'indigo'}
      onClick={() => setColorScheme(isDark ? 'light' : 'dark')}
      title={label}
      aria-label={label}
      {...props}
    >
      {isDark ? (
        <IconSun style={{ width: 18, height: 18 }} />
      ) : (
        <IconMoon style={{ width: 18, height: 18 }} />
      )}
    </ActionIcon>
  );
};
